// Pixel Mecha Bold <https://www.pentacom.jp/pentacom/bitfontmaker2/gallery/?id=521>,
// the title font of the 2027 poster ("Säkerhets-SM 2027"). Copied from
// 2027-poster/src/render/fonts.rs in sakerhetssm-generated-graphics.
// Each glyph is 16 rows, bit x of a row is pixel column x.

export const PIXEL_MECHA_BOLD = {
    '!': [12, 12, 12, 12, 12, 12, 12, 12, 12, 0, 12, 12, 0, 0, 0, 0],
    '"': [108, 108, 108, 108, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    '#': [216, 216, 216, 508, 508, 216, 216, 216, 508, 508, 216, 216, 0, 0, 0, 0],
    $: [48, 252, 252, 12, 12, 252, 252, 192, 192, 252, 252, 48, 0, 0, 0, 0],
    '%': [12, 222, 222, 108, 96, 48, 48, 24, 216, 492, 492, 192, 0, 0, 0, 0],
    '&': [252, 252, 204, 204, 252, 120, 248, 252, 460, 972, 1020, 764, 0, 0, 0, 0],
    "'": [12, 12, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    '(': [24, 28, 12, 12, 12, 12, 12, 12, 12, 12, 28, 24, 0, 0, 0, 0],
    ')': [12, 28, 24, 24, 24, 24, 24, 24, 24, 24, 28, 12, 0, 0, 0, 0],
    '*': [108, 124, 56, 124, 108, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    '+': [0, 0, 0, 96, 96, 96, 1020, 1020, 96, 96, 96, 96, 0, 0, 0, 0],
    ',': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12, 12, 12, 12, 0, 0],
    '-': [0, 0, 0, 0, 0, 0, 252, 252, 0, 0, 0, 0, 0, 0, 0, 0],
    '.': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12, 12, 0, 0, 0, 0],
    '/': [0, 192, 192, 96, 96, 48, 48, 24, 24, 12, 12, 0, 0, 0, 0, 0],
    0: [252, 252, 204, 204, 220, 252, 252, 236, 204, 204, 252, 252, 0, 0, 0, 0],
    1: [28, 28, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 0, 0, 0, 0],
    2: [252, 252, 192, 192, 192, 252, 252, 12, 12, 12, 252, 252, 0, 0, 0, 0],
    3: [252, 252, 192, 192, 192, 240, 240, 192, 192, 192, 252, 252, 0, 0, 0, 0],
    4: [204, 204, 204, 204, 204, 252, 252, 192, 192, 192, 192, 192, 0, 0, 0, 0],
    5: [252, 252, 12, 12, 12, 252, 252, 192, 192, 192, 252, 252, 0, 0, 0, 0],
    6: [252, 252, 12, 12, 12, 252, 252, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    7: [252, 252, 192, 192, 192, 224, 112, 48, 48, 48, 48, 48, 0, 0, 0, 0],
    8: [252, 252, 204, 204, 204, 252, 252, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    9: [252, 252, 204, 204, 204, 252, 252, 192, 192, 192, 252, 252, 0, 0, 0, 0],
    ':': [0, 0, 0, 0, 0, 12, 12, 0, 0, 0, 12, 12, 0, 0, 0, 0],
    ';': [0, 0, 0, 0, 0, 0, 12, 12, 0, 0, 12, 12, 12, 12, 0, 0],
    '<': [0, 0, 0, 0, 96, 112, 56, 28, 28, 56, 112, 96, 0, 0, 0, 0],
    '=': [0, 0, 0, 0, 0, 252, 252, 0, 252, 252, 0, 0, 0, 0, 0, 0],
    '>': [0, 0, 0, 0, 12, 28, 56, 112, 112, 56, 28, 12, 0, 0, 0, 0],
    '?': [252, 252, 204, 192, 192, 224, 112, 48, 48, 0, 48, 48, 0, 0, 0, 0],
    A: [252, 252, 204, 204, 204, 252, 252, 204, 204, 204, 204, 204, 0, 0, 0, 0],
    B: [252, 252, 204, 204, 204, 124, 124, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    C: [252, 252, 12, 12, 12, 12, 12, 12, 12, 12, 252, 252, 0, 0, 0, 0],
    D: [124, 252, 204, 204, 204, 204, 204, 204, 204, 204, 252, 124, 0, 0, 0, 0],
    E: [252, 252, 12, 12, 12, 124, 124, 12, 12, 12, 252, 252, 0, 0, 0, 0],
    F: [252, 252, 12, 12, 12, 124, 124, 12, 12, 12, 12, 12, 0, 0, 0, 0],
    G: [252, 252, 12, 12, 12, 236, 236, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    H: [204, 204, 204, 204, 204, 252, 252, 204, 204, 204, 204, 204, 0, 0, 0, 0],
    I: [12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 0, 0, 0, 0],
    J: [240, 240, 192, 192, 192, 192, 192, 192, 192, 192, 252, 252, 0, 0, 0, 0],
    K: [204, 204, 204, 204, 204, 124, 124, 204, 204, 204, 204, 204, 0, 0, 0, 0],
    L: [12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 252, 252, 0, 0, 0, 0],
    M: [1020, 1020, 876, 876, 876, 876, 780, 780, 780, 780, 780, 780, 0, 0, 0, 0],
    N: [252, 252, 204, 204, 204, 204, 204, 204, 204, 204, 204, 204, 0, 0, 0, 0],
    O: [252, 252, 204, 204, 204, 204, 204, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    P: [252, 252, 204, 204, 204, 252, 252, 12, 12, 12, 12, 12, 0, 0, 0, 0],
    Q: [252, 252, 204, 204, 204, 204, 204, 204, 204, 236, 252, 252, 96, 64, 0, 0],
    R: [252, 252, 204, 204, 204, 124, 124, 204, 204, 204, 204, 204, 0, 0, 0, 0],
    S: [252, 252, 12, 12, 12, 252, 252, 192, 192, 192, 252, 252, 0, 0, 0, 0],
    T: [252, 252, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 0, 0, 0, 0],
    U: [204, 204, 204, 204, 204, 204, 204, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    V: [204, 204, 204, 204, 204, 204, 204, 204, 204, 252, 120, 48, 0, 0, 0, 0],
    W: [780, 780, 780, 780, 780, 780, 780, 876, 876, 876, 1020, 1020, 0, 0, 0, 0],
    X: [204, 204, 204, 204, 252, 120, 120, 252, 204, 204, 204, 204, 0, 0, 0, 0],
    Y: [204, 204, 204, 204, 204, 252, 120, 48, 48, 48, 48, 48, 0, 0, 0, 0],
    Z: [252, 252, 192, 192, 224, 112, 56, 28, 12, 12, 252, 252, 0, 0, 0, 0],
    '[': [28, 28, 12, 12, 12, 12, 12, 12, 12, 12, 28, 28, 0, 0, 0, 0],
    '\\': [0, 12, 12, 24, 24, 48, 48, 96, 96, 192, 192, 0, 0, 0, 0, 0],
    ']': [28, 28, 24, 24, 24, 24, 24, 24, 24, 24, 28, 28, 0, 0, 0, 0],
    '^': [48, 120, 252, 204, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    _: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 252, 252, 0, 0],
    '`': [12, 28, 24, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    a: [0, 0, 0, 252, 252, 192, 252, 252, 204, 204, 252, 252, 0, 0, 0, 0],
    b: [12, 12, 12, 252, 252, 204, 204, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    c: [0, 0, 0, 252, 252, 12, 12, 12, 12, 12, 252, 252, 0, 0, 0, 0],
    d: [192, 192, 192, 252, 252, 204, 204, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    e: [0, 0, 0, 252, 252, 204, 204, 252, 252, 12, 252, 252, 0, 0, 0, 0],
    f: [240, 240, 48, 252, 252, 48, 48, 48, 48, 48, 48, 48, 0, 0, 0, 0],
    g: [0, 0, 0, 252, 252, 204, 204, 204, 204, 204, 252, 252, 192, 252, 252, 0],
    h: [12, 12, 12, 252, 252, 204, 204, 204, 204, 204, 204, 204, 0, 0, 0, 0],
    i: [12, 12, 0, 12, 12, 12, 12, 12, 12, 12, 12, 12, 0, 0, 0, 0],
    j: [24, 24, 0, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 28, 28, 0],
    k: [12, 12, 12, 204, 204, 204, 124, 124, 204, 204, 204, 204, 0, 0, 0, 0],
    l: [12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 28, 28, 0, 0, 0, 0],
    m: [0, 0, 0, 1020, 1020, 876, 876, 876, 876, 876, 876, 876, 0, 0, 0, 0],
    n: [0, 0, 0, 252, 252, 204, 204, 204, 204, 204, 204, 204, 0, 0, 0, 0],
    o: [0, 0, 0, 252, 252, 204, 204, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    p: [0, 0, 0, 252, 252, 204, 204, 204, 204, 204, 252, 252, 12, 12, 0, 0],
    q: [0, 0, 0, 252, 252, 204, 204, 204, 204, 204, 252, 252, 192, 192, 0, 0],
    r: [0, 0, 0, 252, 252, 12, 12, 12, 12, 12, 12, 12, 0, 0, 0, 0],
    s: [0, 0, 0, 252, 252, 12, 252, 252, 192, 192, 252, 252, 0, 0, 0, 0],
    t: [48, 48, 48, 252, 252, 48, 48, 48, 48, 48, 240, 240, 0, 0, 0, 0],
    u: [0, 0, 0, 204, 204, 204, 204, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    v: [0, 0, 0, 204, 204, 204, 204, 204, 204, 252, 120, 48, 0, 0, 0, 0],
    w: [0, 0, 0, 876, 876, 876, 876, 876, 876, 876, 1020, 1020, 0, 0, 0, 0],
    x: [0, 0, 0, 204, 204, 252, 120, 120, 252, 204, 204, 204, 0, 0, 0, 0],
    y: [0, 0, 0, 204, 204, 204, 204, 204, 204, 204, 252, 252, 192, 252, 252, 0],
    z: [0, 0, 0, 252, 252, 224, 112, 56, 28, 12, 252, 252, 0, 0, 0, 0],
    '{': [56, 56, 24, 24, 24, 28, 28, 24, 24, 24, 56, 56, 0, 0, 0, 0],
    '|': [12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 0, 0],
    '}': [28, 28, 24, 24, 24, 56, 56, 24, 24, 24, 28, 28, 0, 0, 0, 0],
    '¢': [0, 0, 0, 48, 252, 252, 12, 12, 12, 252, 252, 48, 0, 0, 0, 0],
    '£': [0, 248, 248, 216, 24, 24, 124, 124, 408, 504, 504, 0, 0, 0, 0, 0],
    '¥': [0, 204, 204, 204, 252, 120, 252, 252, 48, 252, 252, 48, 0, 0, 0, 0],
    '©': [0, 4092, 8190, 6150, 7158, 7158, 6198, 6198, 7158, 7158, 6150, 8190, 4092, 0, 0, 0],
    '·': [0, 0, 0, 0, 0, 0, 12, 12, 0, 0, 0, 0, 0, 0, 0, 0],
    Ç: [252, 252, 12, 12, 12, 12, 12, 12, 12, 12, 252, 252, 48, 56, 56, 0],
    Å: [48, 72, 48, 0, 252, 252, 204, 204, 252, 252, 204, 204, 0, 0, 0, 0],
    Ä: [204, 204, 0, 252, 252, 204, 204, 252, 252, 204, 204, 204, 0, 0, 0, 0],
    Ö: [72, 0, 252, 252, 204, 204, 204, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    Ü: [72, 0, 204, 204, 204, 204, 204, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    ç: [0, 0, 0, 252, 252, 12, 12, 12, 12, 12, 252, 252, 48, 56, 56, 0],
    ü: [0, 72, 0, 204, 204, 204, 204, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    Ğ: [120, 0, 252, 252, 12, 236, 236, 204, 204, 204, 252, 252, 0, 0, 0, 0],
    ğ: [0, 120, 0, 252, 252, 204, 204, 204, 204, 204, 252, 252, 192, 252, 252, 0],
    İ: [4, 0, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 0, 0, 0, 0],
    ı: [0, 0, 0, 0, 4, 4, 4, 4, 4, 4, 4, 4, 0, 0, 0, 0],
    Ş: [252, 252, 12, 12, 12, 252, 252, 192, 192, 192, 252, 252, 48, 56, 56, 0],
    ş: [0, 0, 0, 252, 252, 12, 252, 252, 192, 192, 252, 252, 48, 56, 56, 0],
    '€': [0, 504, 504, 24, 252, 252, 24, 252, 252, 24, 504, 504, 0, 0, 0, 0],
    å: [48, 48, 0, 252, 252, 192, 252, 252, 204, 204, 252, 252, 0, 0, 0, 0],
    ä: [204, 204, 0, 252, 252, 192, 252, 252, 204, 204, 252, 252, 0, 0, 0, 0],
    ö: [204, 204, 0, 252, 252, 204, 204, 204, 204, 204, 252, 252, 0, 0, 0, 0],
}
